import appHelpers from 'app/app-helpers';
import { closeAllSideMenuItems } from 'auth/actions/session.actions';
import template from './navbar.html';

const mapStateToThis = ({ session, config }) => {
  const { firstName, lastName, loggedIn, locale, pageTitle } = session;
  const { applicationName } = config;
  const userName = `${firstName} ${lastName}`;

  return {
    pageTitle,
    userName,
    loggedIn,
    locale,
    applicationName,
  };
};

const mapDispatchToThis = {
  closeAllSideMenuItems,
};

// eslint-disable-next-line no-undef
@Inject('$scope', '$state', '$window', '$ngRedux', 'Notifications', 'gettextCatalog', 'Responsive')
class NavbarController {
  constructor() {
    this.unsubscribeStore = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onInit() {
    if (this.$window.document.readyState !== 'loading') {
      this.checkWidthAndSetMiniNavBar();
    } else {
      this.$window.document.addEventListener('DOMContentLoaded', this.checkWidthAndSetMiniNavBar());
    }

    this.unsubscribeDeviceChange = this.Responsive.subscribeDeviceChange(() => {
      this.checkWidthAndSetMiniNavBar();
    });
  }

  $onDestroy() {
    this.unsubscribeStore();
    this.unsubscribeDeviceChange();
    this.$window.document.removeEventListener('DOMContentLoaded', this.checkWidthAndSetMiniNavBar(), false);
  }

  checkWidthAndSetMiniNavBar() {
    if (this.Responsive.isMobile || (this.loggedIn && !this.Responsive.isExtraLarge)) {
      this.addMiniNavbar();
    } else {
      this.removeMiniNavbar();
    }
  }

  checkIfUserIsLoggedAndRedirect() {
    if (this.loggedIn) {
      return appHelpers.redirectAfterLogin({
        $state: this.$state,
        Notifications: this.Notifications,
        gettextCatalog: this.gettextCatalog,
      });
    }
    return this.$state.go('home-view');
  }

  removeMiniNavbar() {
    this.$window.document.body.classList.remove('mini-navbar');
  }

  addMiniNavbar() {
    this.closeAllSideMenuItems();
    this.$window.document.body.classList.add('mini-navbar');
  }
}

export default class NavbarComponent {
  constructor() {
    this.controller = NavbarController;
    this.template = template;
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/app/components/navbar/navbar-component.js